import {
    IFrame,
} from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { advHas } from '@src/slide/infrastructure/module/independent/assert/get-set';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IBaseFrameProperty, IFrameProps, IValueProps } from './base.interface';
import BatchUpdateFrame from '../batch-update';
import { ERectProperty } from '../batch-update/batch-update.interface';

export default abstract class BaseFrame implements IBaseFrameProperty {
    protected selectionService?: ISelectionService;
    protected model: IElementBaseModel;
    protected batchUpdateFrameHandler: BatchUpdateFrame;

    public constructor(model: IElementBaseModel) {
        this.model = model;
        this.batchUpdateFrameHandler = new BatchUpdateFrame(model.selectionService);
    }

    public getHeight(): number {
        return this.getValueOfFrame(ERectProperty.HEIGHT);
    }

    public getWidth(): number {
        return this.getValueOfFrame(ERectProperty.WIDTH);
    }

    public getLeft(isOnSlide?: boolean): number {
        return this.getValueOfFrame(ERectProperty.LEFT, isOnSlide);
    }

    public getTop(isOnSlide?: boolean): number {
        return this.getValueOfFrame(ERectProperty.TOP, isOnSlide);
    }

    public getRotate(isOnSlide?: boolean): number {
        return this.getValueOfFrame(ERectProperty.ROTATE, isOnSlide);
    }

    public getFrameInfo(isOperating?: boolean): IFrame {
        return this.getFinalFrameInfo(isOperating);
    }

    public frameOnSlide(frameOfGroup?: IFrame | undefined, isOperation?: boolean | undefined): IFrame {
        return this.getFinalFrameInfo(isOperation, true, frameOfGroup);
    }

    /**
     * 根据参数获取相应的frame
     * @param selectedModel model
     * @param item style中的某一项的key
     * @param isOnSlide 是否相对slide
     * @returns
     */
    protected getFinalFrame = (selectedModel: IElementBaseModel, isOperating?: boolean): IFrame => {
        const { style } = selectedModel.props;
        if (isOperating) {
            const flipH = this.getFrameInfoByOtherData(selectedModel, 'flipH', 0);
            const flipV = this.getFrameInfoByOtherData(selectedModel, 'flipV', 0);
            const rotate = this.getFrameInfoByOtherData(selectedModel, 'rotate', 0);
            const { left, top, width, height } = selectedModel.operationFrame || style;
            return {
                flipH, flipV, rotate,
                left, top, width, height,
            };
        }
        return {
            left: style.left,
            top: style.top,
            width: style.width,
            height: style.height,
            flipH: style.flipH || 0,
            flipV: style.flipV || 0,
            rotate: style.rotate || 0,
        };
    };

    private getValueOfFrame = (type: ERectProperty, isOnSlide?: boolean): number => {
        const frameInfo = isOnSlide ? this.frameOnSlide() : this.getFrameInfo();
        if (isNaN(Number(frameInfo?.[type]))) {
            return Number.NaN;
        }
        return frameInfo?.[type] as number;
    };

    private getFrameInfoByOtherData(model: IElementBaseModel, key: string, defaultValue: number) {
        let base = defaultValue;
        if (advHas(model, `operationFrame.${key}`)) {
            base = model.operationFrame?.[key];
        } else if (advHas(model, `props.style.${key}`)) {
            base = model.props.style[key];
        }
        return base;
    }

    public abstract updateHeight(props: IValueProps): void;
    public abstract updateWidth(props: IValueProps): void;
    public abstract updateLeft(left: number, isOnSlide?: boolean): void;
    public abstract updateTop(top: number, isOnSlide?: boolean): void;
    public abstract updateRotate(rotate: number, isRotateOnSlide?: boolean): void;
    public abstract rotateByCurrent(rotate: number, isRotateOnSlide?: boolean): void;
    public abstract updateFrame(props: IFrameProps): void;
    public abstract updateFrameOnSlide(props: IFrameProps): void;
    protected abstract getFinalFrameInfo(isOperating?: boolean, isOnSlide?: boolean, currentFrame?: IFrame): IFrame;
}
